import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

export type DropdownItem = {
    title: string
    action: () => void
}

type DropdownProps = {
  isOpen: boolean
  setClosed: () => void
  items: DropdownItem[]
}

const Dropdown: React.FunctionComponent<DropdownProps> = ({ children, isOpen, items, setClosed }) => {
    useEffect(() => {
        const handleEsc = (event: any) => {
           if (event.key === 'Escape') {
            setClosed()
          }
        };
        window.addEventListener('keydown', handleEsc);
    
        return () => {
          window.removeEventListener('keydown', handleEsc);
        };
      }, []);

    return (
        <Container>
            <DropdownWrapper isOpen={isOpen}>
                {
                    items.map((itm, idx) => (
                        <DropdownItem onClick={() => { itm.action(); setClosed() }} key={idx}>
                            { itm.title }
                        </DropdownItem>
                    ))
                }
            </DropdownWrapper>
            {children}
        </Container>
    )
}

const Container = styled.div`
  position: relative;

  cursor: pointer;
  z-index: 11;
`

const DropdownWrapper = styled.div<{ isOpen: boolean }>`
    display: ${p => p.isOpen ? 'grid' : 'none'};
    grid-template-columns: 1fr;

    position: absolute;
    top: 100%;
    right: 0;
    
    width: fit-content;

    border: 1px solid ${p => p.theme.colors.serviceGray};
    border-radius: 10px;
    
    overflow: hidden;
    z-index: 10;
`

const DropdownItem = styled.div`
    display: grid;

    padding: 10px 70px;

    background: ${p => p.theme.colors.bg};
    
    color: ${p => p.theme.colors.main};
    font-size: 16px;

    cursor: pointer;

    /* So the item is always one line */
    white-space: nowrap;

    &:hover {
        color: ${p => p.theme.colors.bg};
        background: ${p => p.theme.colors.accent};
    }
`

export default Dropdown